import src from "IMAGE";
export default { src, width: 1891, height: 889, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARUlEQVR42k2LSQoAMQgEvSVq3E79/58OIxhyaKooaFprYe+NoYhc/0eqgnMOmBmq2j4UYVBmoqo6uHvvbRQRHedlZnjbB78uB0H4DYXLAAAAAElFTkSuQmCC"};
